//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQAvatarUploader from "@/components/Generics/AQAvatarUploader/AQAvatarUploader.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    name: "AddProcessModal",
    components: {
        AQAvatarUploader,
        AQDialog,
        AQDropdown,
        AQInput
    },
    data() {
        return {
            createNewApp: true,
            appName: "",
            appCode: "",
            appType: "",
            appDescription: "",
            appNameError: false,
            selectedTypeValidation: false,
            isEmptyCode: false,
            duplicateCode: false,
            codeMatchesRegex: true,
            typeOptions: [
                {
                    label: "Standard",
                    value: "STANDARD"
                },
                {
                    label: "Blockchain",
                    value: "BLOCKCHAIN"
                }
            ]
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        codeError() {
            return this.duplicateCode || this.isEmptyCode || !this.codeMatchesRegex;
        },
        codeValidator() {
            let msg = "";
            if (this.isEmptyCode) {
                msg = this.$t("apps.codeMandatory");
            } else if (!this.codeMatchesRegex) {
                msg = this.$t("apps.codeRegex");
            } else if (this.duplicateCode) {
                msg = this.$t("apps.codeDuplicate");
            }
            return msg;
        }
    },
    mounted() {
        document.addEventListener("keydown", this.onKeyDown, false);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.onKeyDown, false);
    },
    methods: {
        createAppBtn() {
            this.appNameError = !this.appName;
            this.selectedTypeValidation = !this.appType;
            this.isEmptyCode = !this.appCode;
            if (!this.appNameError && !this.codeError && !this.selectedTypeValidation) {
                const regex = new RegExp("^([0-9A-Z]){2,5}$");
                if (this.appCode) {
                    this.codeError = false;
                    this.appCode = this.appCode.toUpperCase();
                    this.codeMatchesRegex = regex.test(this.appCode);
                    if (this.codeMatchesRegex) {
                        this.$store.dispatch("apps/isDuplicatedCode", this.appCode).then(data => {
                            if (data) {
                                this.duplicateCode = data.data;
                                this.createNewApp = data.data;
                            }
                            if (!this.codeError) {
                                this.createApp();
                            }
                        });
                    } else {
                        this.createNewApp = true;
                    }
                } else {
                    this.isEmptyCode = true;
                }
            } else {
                this.createNewApp = true;
            }
        },
        onKeyDown(ev) {
            if (ev.keyCode === 27) {
                this.resetCreateAppValues();
            }
        },
        resetCreateAppValues() {
            this.appName = "";
            this.appCode = "";
            this.appType = "";
            this.appDescription = "";
            this.resetCodeError();
            this.appNameError = false;
            this.selectedTypeValidation = false;
            this.createNewApp = false;
            this.$emit("resetModal");
        },
        resetCodeError() {
            this.duplicateCode = false;
            this.isEmptyCode = false;
            this.codeMatchesRegex = true;
        },
        avatarChange(avatar) {
            this.currentApp.image = avatar;
        },
        removeAvatar() {
            this.currentApp.image = "";
        },
        getCode() {
            this.appNameError = false;
            this.resetCodeError();
            const nameToSend = this.appName.replace(/\\/g, "");
            this.$store.dispatch("apps/getCodeByAppName", { appName: nameToSend }).then(data => {
                if (data && data.data) {
                    this.appCode = data.data;
                }
            });
        },
        selectAppType(val) {
            this.appType = val;
            this.selectedTypeValidation = false;
        },
        createApp() {
            if (this.appName && this.appCode && this.appType && (!this.currentApp.image || (this.currentApp.image && this.currentApp.image.size < 10000000))) {
                this.currentApp.name = this.appName;
                this.currentApp.code = this.appCode;
                this.currentApp.description = this.appDescription;
                this.currentApp.blockchainType = this.appType === "BLOCKCHAIN" ? "BLOCKCHAIN" : "STANDARD";
                if (!this.appNameError && !this.selectedTypeValidation && !this.duplicateCode && !this.isEmptyCode && this.codeMatchesRegex) {
                    this.$root.$emit(`${this.$route.name}Save`);
                    this.$root.$emit("noMenu", false);
                    this.$emit("resetModal");
                    this.$store.commit("admin/setGroupsAppList");
                }
            }

            if (this.currentApp.image && this.currentApp.image.size > 10000000) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("userProfile.uploadedProfileImageSizeError")
                });
            }
        }
    }
};
